// --- External Libraries
import moment from 'moment-timezone';
// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const statusIndicator = {
    headerName: '',
    field: 'spaJobStatus',
    width: 20,
    cellRenderer: (params) => (
        <div style={{ position: 'relative', width: '100%', height: '100%', background: '#fff' }}>
            <div
                style={{
                    position: 'absolute',
                    left: 2,
                    top: 0,
                    bottom: 0,
                    width: '4px',
                    background: getColorForStatus(params.value),
                    borderRadius: '2px',
                }}
            />
            <span
                style={{
                    marginLeft: '4px',
                    background: getColorForStatus(params.value),
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                }}
            >
                &nbsp;
            </span>
        </div>
    ),
    cellStyle: { padding: 0 },
    suppressMenu: true,
    sortable: false,
    filter: false,
};
export const id = {
    field: 'id',
    headerName: 'ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'jobs',
    },
    minWidth: 100,
};

export const spaJobType = {
    field: 'spaJobType',
    headerName: 'Job Type',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'spaJobType',
        page: 'jobs',
    },
    minWidth: 300,
};

export const spaJobStatus = {
    field: 'spaJobStatus',
    headerName: 'Job Status',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'spaJobStatus',
        page: 'jobs',
    },
    minWidth: 100,
};

export const targetCount = (
    onOpenJobTasksModal,
) => ({
    field: 'targetCount',
    headerName: 'Target',
    cellRenderer: ClickableCellRenderer(onOpenJobTasksModal, ''),
    minWidth: 100,
});

export const progressCount = {
    field: 'progressCount',
    headerName: 'Progress',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'progressCount',
        page: 'jobs',
    },
    minWidth: 100,
};

export const errorCount = {
    field: 'errorCount',
    headerName: 'Errors',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'errorCount',
        page: 'jobs',
    },
    minWidth: 100,
};

export const startedByUser = {
    field: 'startedByUser',
    headerName: 'Started By',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'startedByUser',
        page: 'jobs',
    },
    minWidth: 200,
};

export const createdAt = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).tz(moment.tz.guess()).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'jobs',
    },
    minWidth: 200,
};

export const completedAt = {
    field: 'completedAt',
    headerName: 'Completed',
    valueFormatter: ({ value }) => (value ? moment(value).tz(moment.tz.guess()).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'completedAt',
        page: 'jobs',
    },
    minWidth: 200,
};

// Helper function for color mapping
function getColorForStatus(status) {
    const s = (status || '').toUpperCase();
    if (['COMPLETE', 'STARTING', 'READY', 'CREATED', 'VALIDATING', 'RUNNING'].includes(s)) {
        return '#4caf50';
    }
    if (['FAILED', 'INVALID', 'ABORTED', 'ERROR'].includes(s)) {
        return '#f44336';
    }
    return '#ccc';
}
